import React from 'react';
import { ButtonGroup, ButtonGroupTypes } from 'devextreme-react/button-group';
import { SingleMultipleOrNone } from 'devextreme/ui/button_group';

export type ToggleButtonItem = {
    id: string;
    icon?: string;
    text: string;
    alignment?: string;
    hint?: string;
};

export interface IToggleButtonOptions {
    id: string;
    items: ToggleButtonItem[];
    selectedItems?: string[];
    selectionMode: SingleMultipleOrNone | undefined;
    stylingMode: ButtonGroupTypes.ButtonStyle;
    onItemClick?(e: ButtonGroupTypes.ItemClickEvent): void;
    width?: string;
    height?: string;
}

export const ToggleButton: React.FC<IToggleButtonOptions> = ({
    id,
    width = 'auto',
    height = 'auto',
    items,
    selectedItems,
    selectionMode,
    stylingMode,
    onItemClick,
}) => {

    return (
        <>
            <div className='togglebuttongroup-container'>
                <ButtonGroup
                    id={id}
                    items={items}
                    keyExpr='id'
                    selectionMode={selectionMode}
                    stylingMode={stylingMode}
                    selectedItemKeys={selectedItems}
                    onItemClick={onItemClick}
                    width={width}
                    height={height}
                />
            </div>
        </>
    );
};
